import { Flex } from "@chakra-ui/layout";
import type { ConsultantAccount } from "@models/ConsultantAccount";
import { getConsultantCompetences } from "@utils/utils";
import { useOrganisation } from "@api/hooks";
// @ts-ignore - colord has module resolution issues in strict mode
import { colord } from "colord";
import { appTheme } from "@styles/Theme";

interface Props {
	competences: ConsultantAccount["profile"]["competences"];
}

export const ConsultantCompetencePills: React.FC<Props> = ({ competences, ...rest }) => {
	const { organisation, isLoading } = useOrganisation();

	if (isLoading) {
		return null;
	}

	return (
		<Flex align={["center", "center", "flex-start", "flex-start"]}>
			<Flex
				w="100%"
				direction={"row"}
				flexWrap={"wrap"}
				gap={"0.4rem"}
				justifyContent={["center", "center", "flex-start"]}
			>
				{getConsultantCompetences(competences, organisation?.competences).map((str) => {
					return (
						<Flex
							fontStyle={"normal"}
							fontWeight={500}
							fontSize={"14px"}
							lineHeight={"17px"}
							align={"center"}
							textAlign={"center"}
							display={"inline-block"}
							color={"black"}
							padding={["5px 9px", null, null, "6px 12px"]}
							key={str}
							background={colord(appTheme.colors.accent).alpha(0.2).toRgbString()}
							border={`1px solid ${appTheme.colors.accent}`}
							borderRadius={"40px"}
							{...rest}
						>
							{str}
						</Flex>
					);
				})}
			</Flex>
		</Flex>
	);
};
